import { useWorkOSAuth } from './useWorkOSAuth'
import type { Profile, RoleType, Permissions } from 'types'

// Map WorkOS user to legacy Profile type for backward compatibility
function mapWorkOSUserToProfile(user: any): Profile | null {
  if (!user) return null

  const firstName = user.firstName ?? user.fullName?.split(' ')[0] ?? ''
  const lastName =
    user.lastName ??
    (user.fullName ? user.fullName.split(' ').slice(1).join(' ') : '') ??
    ''

  const rawRoleName = (user.role?.name || '').toLowerCase()
  const roleMap: Record<string, RoleType> = {
    platform_admin: 'platform_admin',
    platform_manager: 'platform_manager',
    company_admin: 'company_admin',
    team_member: 'company_team_member',
  }

  const roleType = roleMap[rawRoleName] || 'company_team_member'
  const roleLevel = roleType === 'company_admin' ? 3 : roleType === 'platform_admin' ? 1 : roleType === 'platform_manager' ? 2 : 4

  const permissions: string[] = Array.isArray(user.role?.permissions)
    ? user.role?.permissions
    : []

  const nowIso = new Date().toISOString()

  return {
    id: user.id,
    first_name: firstName,
    last_name: lastName,
    phone: '', // Not available in WorkOS profile
    email: user.email,
    avatar: user.avatar ?? null,
    active: true,
    role_id: user.role?.id ?? '',
    role: {
      id: user.role?.id ?? '',
      name: roleType,
      level: roleLevel,
      created_at: nowIso,
      updated_at: null,
      permissions: permissions.map((perm) => ({
        id: perm,
        name: perm as Permissions,
        description: `${perm} permission`,
        created_at: nowIso,
        updated_at: null,
      })),
    },
    created_at: nowIso,
    updated_at: nowIso,
  }
}

export function useAuth() {
  const { user, isAuthenticated, logout: workosLogout } = useWorkOSAuth()

  const logout = async () => {
    await workosLogout()
  }

  return {
    profile: mapWorkOSUserToProfile(user),
    isAuthenticated,
    logout,
  }
}
